module.exports = __webpack_public_path__ + "static/media/img_device_mobile.e6240c01.png";